<section class="contact-section1">
    <div class="container">
        <div class="row min-vh-5" style="padding: 40px;">
            <div class="col-lg-12 ">
                <div class="contact-form">
                    <div class="row">
                        <div class="col-lg-12">
                            <section class="login-page section-b-space">
                                <div class="container">
                                    <div class="custom-form">
                                        <div class="row">
                                            <h2> Vendor Login</h2>
                                            <div class="col-lg-12">
                                                <form [formGroup]="adminLoginForm">
                                                    <div class="col-md-12 mt-3">
                                                        <label>Email</label>
                                                        <input formControlName="email" type="email" class="form-control"
                                                            placeholder="Enter your email" />

                                                        <!-- ✅ Error messages with reserved space -->
                                                        <div class="error-container">
                                                            <small
                                                                *ngIf="adminLoginForm.get('email')?.touched && adminLoginForm.get('email')?.errors?.['required']">
                                                                Email is required.
                                                            </small>

                                                        </div>
                                                    </div>

                                                    <div class="col-md-12 mt-3">
                                                        <label for="password">Password</label>
                                                        <div class="position-relative">
                                                            <input [type]="passwordVisible ? 'text' : 'password'"
                                                                class="form-control pr-5" formControlName="password"
                                                                placeholder="Enter password" />
                                                            <mat-icon class="password-toggle-icon"
                                                                (click)="passwordVisible = !passwordVisible">
                                                                {{ passwordVisible ? 'visibility' : 'visibility_off' }}
                                                            </mat-icon>
                                                        </div>

                                                        <!-- ✅ Error messages with reserved space -->
                                                        <div class="error-container">
                                                            <small
                                                                *ngIf="adminLoginForm.get('password')?.touched && adminLoginForm.get('password')?.errors?.['required']">
                                                                Password is required.
                                                            </small>

                                                        </div>
                                                    </div>


                                                    <!--  <div class="col-md-12 mt-3">
                                                        <label for="">Email</label>
                                                        <input formControlName="email" type="email" class="form-control"
                                                            placeholder="" />
                                                    </div>

                                                    <div class="col-md-12 position-relative" style="margin-top: 6%;">
                                                        <label for="password">Password</label>&nbsp;
                                                            <input class="form-control pr-5" formControlName="password"
                                                                placeholder="" />
                                                            
                                                    </div> -->
                                                    <div style="display: flex; width: 100%;">

                                                        <div style="width: 80%;margin-top: 4%; cursor: pointer;">
                                                            If not registered yet
                                                            <a class="primary-color"
                                                                class="forgot-password-link"><strong
                                                                    style="color: #BF0000;"
                                                                    (click)="goTo('/sign-up')">CLICK
                                                                    HERE</strong> </a>
                                                        </div>
                                                        <div style="width: 20%; margin-top: 4%; ">
                                                            <button (click)="validateVendor()"
                                                                class="btn btn-solid _button" [disabled]="!adminLoginForm.valid">Submit</button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- <section class="login-page section-b-space">
    <div class="container">
        <div class="custom-form-1">
            <div class="row">
                <div class="col-lg-2"></div>

                <div class="col-lg-8">
                    <div class="theme-card">
                        <h2> Vendor Login</h2>
                        <form [formGroup]="adminLoginForm">
                            <div class="form-group form-group-change">
                                <mat-form-field appearance="outline">
                                    <mat-label>Email</mat-label>
                                    <input matInput type="email" id="email" formControlName="email"
                                        placeholder=" Email">
                                    <mat-error *ngIf="adminLoginForm.get('email').hasError('required')">This field is
                                        required</mat-error>
                                </mat-form-field>
                            </div>

                            <div class="form-group form-group-custom">
                                <mat-form-field appearance="outline">
                                    <mat-label>Password</mat-label>
                                    <input matInput [type]="showpassword ? 'text' : 'password'" id="password"
                                        formControlName="password" placeholder="password">
                                    <button mat-icon-button type="button" matSuffix (click)="toggleShow($event)">
                                        <span *ngIf="!showpassword">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                height="24" fill="none">
                                                <path
                                                    d="M21.544 11.045C21.848 11.4713 22 11.6845 22 12C22 12.3155 21.848 12.5287 21.544 12.955C20.1779 14.8706 16.6892 19 12 19C7.31078 19 3.8221 14.8706 2.45604 12.955C2.15201 12.5287 2 12.3155 2 12C2 11.6845 2.15201 11.4713 2.45604 11.045C3.8221 9.12944 7.31078 5 12 5C16.6892 5 20.1779 9.12944 21.544 11.045Z"
                                                    stroke="currentColor" stroke-width="1.5" />
                                                <path
                                                    d="M15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12Z"
                                                    stroke="currentColor" stroke-width="1.5" />
                                            </svg>
                                        </span>
                                        <span *ngIf="showpassword">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24"
                                                height="24" fill="none">
                                                <path
                                                    d="M19.439 15.439C20.3636 14.5212 21.0775 13.6091 21.544 12.955C21.848 12.5287 22 12.3155 22 12C22 11.6845 21.848 11.4713 21.544 11.045C20.1779 9.12944 16.6892 5 12 5C11.0922 5 10.2294 5.15476 9.41827 5.41827M6.74742 6.74742C4.73118 8.1072 3.24215 9.94266 2.45604 11.045C2.15201 11.4713 2 11.6845 2 12C2 12.3155 2.15201 12.5287 2.45604 12.955C3.8221 14.8706 7.31078 19 12 19C13.9908 19 15.7651 18.2557 17.2526 17.2526"
                                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M9.85786 10C9.32783 10.53 9 11.2623 9 12.0711C9 13.6887 10.3113 15 11.9289 15C12.7377 15 13.47 14.6722 14 14.1421"
                                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                                                <path d="M3 3L21 21" stroke="currentColor" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </button>
                                    <mat-error *ngIf="adminLoginForm.get('password').hasError('required')">Password is
                                        required.</mat-error>
                                </mat-form-field>
                            </div>

                            <div style="display: flex; width: 100%;">

                                <div style="width: 80%;margin-top: 4%; cursor: pointer;">
                                    If not registered yet 
                                    <a class="primary-color" class="forgot-password-link"><strong
                                            style="color: #BF0000;" (click)="goTo('/sign-up')">CLICK
                                            HERE</strong> </a>
                                </div>
                                <div style="width: 20%;">
                                    <button (click)="validateVendor()" class="btn btn-solid _button">Submit</button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
                <div class="col-lg-2"></div>

            </div>
        </div>
    </div>
</section> -->